const updateChildrensParent = (cardChildren, id, entity) => {
  const hasCardChildren = !!cardChildren && Object.keys(cardChildren).length && cardChildren.props;

  if (hasCardChildren && cardChildren.props.children) {
    const childItems = cardChildren.props.children;

    childItems.length > 1 &&
      childItems[1].forEach(
        child =>
          // eslint-disable-next-line no-param-reassign
          (child.props.options.parent = {
            ...child.props.options.parent,
            itemId: id,
            itemEntity: entity
          })
      );
  }
};

export default updateChildrensParent;
